import { render, staticRenderFns } from "./LmsMyJourney.vue?vue&type=template&id=8b07be76&scoped=true"
import script from "./LmsMyJourney.vue?vue&type=script&lang=js"
export * from "./LmsMyJourney.vue?vue&type=script&lang=js"
import style0 from "./LmsMyJourney.vue?vue&type=style&index=0&id=8b07be76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b07be76",
  null
  
)

export default component.exports